import React from "react";
import Back from "features/metadesk/components/Back";
import { Box } from "@mui/material";
import { useIntl } from "react-intl";
import {
  StyledCircle,
  StyledStatusText,
} from "./NotificationDetailContent.styles";
import Grid from "@metacrm/metacrm-material-ui/dist/Grid";
import NotificationInfoArea from "./NotificationInfoArea/NotificationInfoArea";
import NotificationPreview from "./NotificationPreview";
import { parseCustomDomainUrl } from "features/helpers/utils";
import { useOutletContext } from "react-router-dom";

const NotificationDetailContent = ({ status = "scheduled" }) => {
  const { formatMessage } = useIntl();
  const [entityName, isCustomDomain] = useOutletContext();
  const queryString = window.location.search;

  return (
    <Box>
      <Back noMt></Back>
      <Box display={"flex"} alignItems={"center"} mb={1}>
        <Box className="title">
          {formatMessage({ id: "notification.create.title" })}
        </Box>
        <Box display={"flex"} alignItems={"center"} ml="12px">
          <StyledCircle status={status}></StyledCircle>
          <StyledStatusText status={status}>
            {formatMessage({ id: `global.campaignStatus.${status}` })}
          </StyledStatusText>
        </Box>
      </Box>

      <Box color={(theme) => theme.customColors.grey[600]} mb={2}>
        {formatMessage({ id: "notification.create.description" })}
      </Box>

      <Box>
        <Grid container spacing={1.5}>
          <Grid item xs={12} md={6}>
            <NotificationInfoArea status={status}></NotificationInfoArea>
          </Grid>
          <Grid item xs={12} md={6}>
            <NotificationPreview />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default NotificationDetailContent;
